interface TimeSlotPickerProps {
  selectedTime: string;
  onSelect: (time: string) => void;
  slots?: { Time: string; Capacity: number; Booked: number; Available: boolean }[];
  loading?: boolean;
}

function periodOf(time: string) {
  return Number(time.slice(0, 2)) < 12 ? '上午' : '下午';
}

export default function TimeSlotPicker({ selectedTime, onSelect, slots = [], loading = false }: TimeSlotPickerProps) {
  const groups = [
    { label: '上午', icon: 'ri-sun-line', slots: slots.filter((slot) => periodOf(slot.Time) === '上午') },
    { label: '下午', icon: 'ri-sun-foggy-line', slots: slots.filter((slot) => periodOf(slot.Time) === '下午') },
  ].filter((period) => period.slots.length > 0);

  if (loading) {
    return <div className="rounded-xl border border-[#E8E0D6] bg-white px-4 py-5 text-sm text-[#9A8A7A]">時段載入中...</div>;
  }

  if (groups.length === 0) {
    return <div className="rounded-xl border border-[#E8E0D6] bg-white px-4 py-5 text-sm text-[#9A8A7A]">請先選擇可預約日期。</div>;
  }

  return (
    <div className="w-full space-y-5">
      {groups.map((period) => (
        <div key={period.label}>
          <div className="flex items-center gap-2 mb-3">
            <div className="w-7 h-7 rounded-full bg-[#1B3D2A]/10 flex items-center justify-center">
              <i className={`${period.icon} text-sm text-[#1B3D2A]`} />
            </div>
            <span className="text-sm font-bold text-[#1B3D2A]">{period.label}</span>
          </div>
          <div className="flex flex-wrap gap-2">
            {period.slots.map((slot) => {
              const selected = selectedTime === slot.Time;
              return (
                <button
                  key={slot.Time}
                  type="button"
                  disabled={!slot.Available}
                  onClick={() => onSelect(slot.Time)}
                  className={`px-3.5 py-2 min-h-[44px] rounded-lg text-sm font-medium transition-all duration-200 border
                    ${selected
                      ? 'bg-[#1B3D2A] text-white border-[#1B3D2A]'
                      : !slot.Available
                        ? 'bg-[#f5f5f5] text-[#b7aea5] border-[#E8E0D6] cursor-not-allowed'
                      : 'bg-white text-[#1B3D2A] border-[#E8E0D6] hover:border-[#D4A574]/50 hover:bg-[#FAF8F5]'
                    }`}
                >
                  {slot.Time}
                  {!slot.Available && <span className="ml-1 text-xs">額滿</span>}
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
